import axios from '../../../axios';
import BulkContactUpdateDTO from '../types/BulkContactUpdateDTO';
import ClientContactDTO from '../types/ClientContactDTO';
import ClientContactIdsDto from '../types/ClientContactIdsDto';
import ClientOwnerDTO from '../types/ClientOwnerDTO';
import ClientRequestDTO from '../types/ClientRequestDTO';
const url = 'invoicingservice/api/client-contact';

export const getClientContact = (
  clientId: string,
  pageNo = 0,
  pageSize = 5,
  query = '',
  sortBy = '',
  sortOrder = '',
  clientContactStatus: string[] = [],
  clientContactTags: string[] = []
) =>
  axios.get(
    `${url}/${clientId}/list?pageNo=${pageNo}&pageSize=${pageSize}&query=${
      query ?? ''
    }&sortBy=${sortBy}&sortOrder=${sortOrder}&clientContactStatus=${clientContactStatus}&clientContactTags=${clientContactTags}`
  );

export const checkClientContactAccess = (clientId: string, clientContactId: string) =>
  axios.get(`${url}/${clientId}/check-access?clientContactId=${clientContactId}`);

export const saveClientContact = (payload: ClientContactDTO) =>
  axios.post(`${url}/save-contacts`, payload);
export const updateClientContact = (payload: ClientContactDTO) =>
  axios.put(`${url}/update-client-contact`, payload);
export const deleteClientContact = (id: string) => axios.delete(`${url}/${id}`);
export const autocompleteClientRecruiterName = (
  search: string,
  clientId: string,
  excludeContact?: string | null
) =>
  axios.get(
    `${url}/autocomplete?search=${search}&clientId=${clientId}${
      excludeContact ? '&excludeContact=' + excludeContact : ''
    }`
  );

export const autocompleteClientRecruiter = (clientContactSearch: string, clientIds: string[]) => {
  const searchText = `${encodeURIComponent(getFullTextSearchString(clientContactSearch))}`;
  const params = new URLSearchParams();
  clientIds.forEach((clientId) => {
    params.append('clientIds[]', clientId);
  });
  return axios.get(`${url}/autocomplete/${searchText}?${params.toString()}`);
};

export const getClientContactAutocompleteOptions = (contactSearch: string, clientId: string) =>
  autocompleteClientRecruiterName(
    `${encodeURIComponent(contactSearch)
      .trim()
      .split(' ')
      .map((term) => term + ':*')
      .join(' & ')}`,
    clientId
  );

export const findByEmailAndClientId = (email: string, clientId: string) =>
  axios.get(`${url}/get-by-client-id-email?email=${email}&clientId=${clientId}`);

export const getFullTextSearchString = (search: string) =>
  search
    .trim()
    .split(' ')
    .map((s) => s + ':*')
    .join(' & ');

export const getClientContactById = (id: string) => axios.get(`${url}/${id}`);

export const updateClientContactStatus = (id: string, markStatus: boolean) =>
  axios.put(`${url}/update-status/${id}/${markStatus}`);

export const getClientContactCount = (clientId: string) =>
  axios.get(`${url}/${clientId}/getClientContactCount`);
export const getClientContactByClientIds = (payload: ClientContactIdsDto) =>
  axios.post(`${url}/get-by-client-ids`, payload);

export const getClientContactByIds = (payload: ClientContactIdsDto) =>
  axios.post(`${url}/get-by-ids`, payload);

export const getAllContacts = (payload: ClientRequestDTO) =>
  axios.post(`${url}/get-all-by-workspaceid`, payload);

export const autocompleteContactName = (search: string) =>
  axios.get(`${url}/filter/autocomplete?search=${search}`);

export const getTotalClientContactCount = (clientId: string) =>
  axios.get(`${url}/${clientId}/get-total-client-contact-count`);

export const getAllTagsByClientId = (clientId: string) => axios.get(`${url}/tags/${clientId}`);

export const getAllTags = () => axios.get(`${url}/tags`);

export const saveClientContacts = (payload: ClientContactDTO[]) =>
  axios.post(`${url}/saveall`, payload);

export const updateClientContactOwner = (id: string, payload: ClientOwnerDTO) =>
  axios.put(`${url}/update-owner/${id}`, payload);

export const updateContactEntityType = (id: string, entityType: string[]) =>
  axios.put(`${url}/${id}/entity-type`, entityType);

export const bulkUpdateContactOwner = (bulkUpdateDTO: BulkContactUpdateDTO) =>
  axios.put(`${url}/bulk/update-owner`, bulkUpdateDTO);

export const bulkUpdateContactStatus = (bulkUpdateDTO: BulkContactUpdateDTO) =>
  axios.put(`${url}/bulk/update-status`, bulkUpdateDTO);

export const bulkUpdateContactDncDetails = (bulkUpdateDTO: BulkContactUpdateDTO) =>
  axios.put(`${url}/bulk/update-dnc-details`, bulkUpdateDTO);

export const bulkAssignContactUsers = (bulkUpdateDTO: BulkContactUpdateDTO) =>
  axios.put(`${url}/bulk/assign-users`, bulkUpdateDTO);
